import { OpportunitySortBy, OpportunitySortOrder } from "../../../lib/types/graphQLEnums";

export const mapSortFieldToEnum = (field: string): OpportunitySortBy => {
  switch (field) {
    case "name":
      return OpportunitySortBy.Name;
    case "value":
      return OpportunitySortBy.Value;
    case "createdAt":
      return OpportunitySortBy.CreatedAt;
    case "updatedAt":
      return OpportunitySortBy.UpdatedAt;
    case "buyerName":
      return OpportunitySortBy.BuyerName;
    case "assignedTo":
      return OpportunitySortBy.AssignedTo;
    case "closeDate":
      return OpportunitySortBy.CloseDate;
    case "stageName":
      return OpportunitySortBy.StageName;
    default:
      return OpportunitySortBy.CreatedAt;
  }
};

export const mapSortOrderToEnum = (order: "ASC" | "DESC"): OpportunitySortOrder => {
  return order === "ASC" ? OpportunitySortOrder.Asc : OpportunitySortOrder.Desc;
};
